import * as React from "react"
import { cn } from "@/lib/utils"

function Textarea({
  className,
  ...props
}) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        // Use your color variables for background, border, text, and placeholder
        "[background-color:var(--neutral-50)] [color:var(--neutral-700)] border border-(--neutral-300) rounded-md px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none min-h-16 w-full field-sizing-content font-sans placeholder:text-[var(--color-muted-foreground)] selection:bg-(--color-primary) selection:text-[var(--color-primary-foreground)] focus-visible:border-[var(--color-ring)] focus-visible:ring-[var(--color-ring)]/50 focus-visible:ring-[3px] aria-invalid:ring-[var(--color-destructive)]/20 dark:aria-invalid:ring-[var(--color-destructive)]/40 aria-invalid:border-(--color-destructive) disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      {...props} />
  );
}

export { Textarea }